export default function SkeletonChart() {
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 animate-pulse">
      <div className="h-5 bg-gray-200 rounded w-48 mb-4"></div>
      <div className="h-64 bg-gray-100 rounded flex items-end justify-around px-4 pb-4">
        {[40,65,80,55,70,45,60,75].map((h, i) => (
          <div key={i} className="bg-gray-200 rounded-t" style={{height: `${h}%`, width: '10%'}}></div>
        ))}
      </div>
    </div>
  );
}
